// Picking boundary: Rust owns scene hit-test traversal and geometry checks.

import { pickScene as pickEngineScene } from 'fluveria-engine-wasm';
import type { LayoutMap } from './layoutEngine.js';
import type { Vec2 } from './layoutMath.js';
import type { Scene, SceneNodeId } from './sceneState.js';

export interface HitResult {
  nodeId: SceneNodeId;
  localPoint: Vec2;
}

export interface PickOptions {
  /**
   * Allow FrameNodes to be returned when the point falls inside the frame but
   * misses every child. Off by default (runtime picking targets visible
   * surfaces only); editor selection turns it on so frames are selectable.
   */
  includeFrames?: boolean;
}

export function pickScene(
  scene: Scene,
  layoutMap: LayoutMap,
  worldPoint: Vec2,
  options: PickOptions = {},
): HitResult | null {
  return (pickEngineScene({
    scene,
    layoutMap: encodeLayoutMapForCore(layoutMap),
    worldPoint,
    options,
  }) as HitResult | null | undefined) ?? null;
}

function encodeLayoutMapForCore(layoutMap: LayoutMap): Record<string, unknown> {
  const encoded: Record<string, unknown> = {};
  for (const [nodeId, layout] of Object.entries(layoutMap)) {
    encoded[nodeId] = {
      ...layout,
      fromLocal: Array.from(layout.fromLocal),
      toLocal: Array.from(layout.toLocal),
    };
  }
  return encoded;
}
